/* eslint-disable */
import type { Money } from "../../../common/currency.pb";
import type { Instrument } from "../../../franklin/api.pb";
import type { Region } from "../../../franklin/region.pb";
import type { TransferRail } from "./model/transfer_rail.pb";

export enum TransferEntityState {
  INITIATING = "INITIATING",
  WAITING_ON_LIMITS = "WAITING_ON_LIMITS",
  WAITING_ON_IDV = "WAITING_ON_IDV",
  WAITING_ON_RISK = "WAITING_ON_RISK",
  WAITING_ON_MONEY_TRANSFER = "WAITING_ON_MONEY_TRANSFER",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  REVERSED = "REVERSED",
  /**
   * WAITING_ON_MONEY_TRANSFER_DECISION - Replaced with WAITING_ON_MONEY_TRANSFER_FAILURE_FIX
   *
   * @deprecated
   */
  WAITING_ON_MONEY_TRANSFER_DECISION = "WAITING_ON_MONEY_TRANSFER_DECISION",
  CHARGED_BACK = "CHARGED_BACK",
  WAITING_ON_MONEY_TRANSFER_FAILURE_FIX = "WAITING_ON_MONEY_TRANSFER_FAILURE_FIX",
  WAITING_ON_MONEY_TRANSFER_TO_PROCESS = "WAITING_ON_MONEY_TRANSFER_TO_PROCESS",
  WAITING_ON_MONEY_TRANSFER_TO_SETTLE = "WAITING_ON_MONEY_TRANSFER_TO_SETTLE",
  WAITING_ON_MANUAL_REVERSAL = "WAITING_ON_MANUAL_REVERSAL",
  WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH = "WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH",
  WAITING_ON_MANUAL_REVERSAL_DECISION = "WAITING_ON_MANUAL_REVERSAL_DECISION",
  WAITING_ON_CUSTOMER_FOR_PARTIAL_AUTHORIZATION = "WAITING_ON_CUSTOMER_FOR_PARTIAL_AUTHORIZATION",
  WAITING_ON_PARTIAL_AUTHORIZATION_TRANSFER = "WAITING_ON_PARTIAL_AUTHORIZATION_TRANSFER",
  WAITING_ON_PARTIAL_AUTHORIZATION_REVERSAL = "WAITING_ON_PARTIAL_AUTHORIZATION_REVERSAL",
  WAITING_ON_DOCUMENT_IDV = "WAITING_ON_DOCUMENT_IDV",
  WAITING_ON_INSTRUMENT_SELECTION = "WAITING_ON_INSTRUMENT_SELECTION",
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION = "WAITING_ON_MONEY_TRANSFER_AUTHORIZATION",
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_ASYNC_RESPONSE = "WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_ASYNC_RESPONSE",
  WAITING_ON_CAPTURE_POLICY_DECISION = "WAITING_ON_CAPTURE_POLICY_DECISION",
  WAITING_ON_MONEY_TRANSFER_CAPTURE = "WAITING_ON_MONEY_TRANSFER_CAPTURE",
  WAITING_ON_MONEY_TRANSFER_CAPTURE_ASYNC_RESPONSE = "WAITING_ON_MONEY_TRANSFER_CAPTURE_ASYNC_RESPONSE",
  WAITING_ON_AUTHORIZATION_REVERSAL = "WAITING_ON_AUTHORIZATION_REVERSAL",
  AUTHORIZED_WAITING_CALLER_ACTION = "AUTHORIZED_WAITING_CALLER_ACTION",
  WAITING_ON_AUTHORIZATION_REVERSAL_ASYNC_RESPONSE = "WAITING_ON_AUTHORIZATION_REVERSAL_ASYNC_RESPONSE",
  WAITING_ON_EXTRA_AUTHENTICATION = "WAITING_ON_EXTRA_AUTHENTICATION",
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_UNBLOCK = "WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_UNBLOCK",
  WAITING_ON_TRANSFER_RAIL_DECISION = "WAITING_ON_TRANSFER_RAIL_DECISION",
  WAITING_ON_RESERVE_LIMITS_USAGE = "WAITING_ON_RESERVE_LIMITS_USAGE",
  PARTIALLY_AUTHORIZED_WAITING_CALLER_ACTION = "PARTIALLY_AUTHORIZED_WAITING_CALLER_ACTION",
}

/**
 * REMINDER: When adding a failure reason, we need to notify our partners, such as Mir, so that they
 * can update their code to correctly map the new failure reason.
 */
export enum FailureReason {
  /** IDV_FAILURE - Prerequisites Failures */
  IDV_FAILURE = "IDV_FAILURE",
  RETRY_EXPIRED = "RETRY_EXPIRED",
  /** UNKNOWN_LIMITS_FAILURE - Limits Check Failures */
  UNKNOWN_LIMITS_FAILURE = "UNKNOWN_LIMITS_FAILURE",
  TRANSACTION_AMOUNT_BELOW_MINIMUM = "TRANSACTION_AMOUNT_BELOW_MINIMUM",
  TRANSACTION_AMOUNT_EXCEEDS_MAXIMUM = "TRANSACTION_AMOUNT_EXCEEDS_MAXIMUM",
  /** @deprecated */
  WEEKLY_CUSTOMER_AMOUNT_EXCEEDED = "WEEKLY_CUSTOMER_AMOUNT_EXCEEDED",
  /** @deprecated */
  MONTHLY_CUSTOMER_AMOUNT_EXCEEDED = "MONTHLY_CUSTOMER_AMOUNT_EXCEEDED",
  /** @deprecated */
  WEEKLY_INSTRUMENT_AMOUNT_EXCEEDED = "WEEKLY_INSTRUMENT_AMOUNT_EXCEEDED",
  /** @deprecated */
  MONTHLY_INSTRUMENT_AMOUNT_EXCEEDED = "MONTHLY_INSTRUMENT_AMOUNT_EXCEEDED",
  CUSTOMER_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = "CUSTOMER_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED",
  CUSTOMER_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = "CUSTOMER_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED",
  CUSTOMER_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = "CUSTOMER_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED",
  CUSTOMER_WEEKLY_SENDING_LIMIT_EXCEEDED = "CUSTOMER_WEEKLY_SENDING_LIMIT_EXCEEDED",
  CUSTOMER_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = "CUSTOMER_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED",
  CUSTOMER_WEEKLY_SENDING_XBORDER_AMOUNT_EXCEEDED = "CUSTOMER_WEEKLY_SENDING_XBORDER_AMOUNT_EXCEEDED",
  CUSTOMER_WEEKLY_RECEIVING_AMOUNT_EXCEEDED = "CUSTOMER_WEEKLY_RECEIVING_AMOUNT_EXCEEDED",
  CUSTOMER_WEEKLY_RECEIVING_XBORDER_AMOUNT_EXCEEDED = "CUSTOMER_WEEKLY_RECEIVING_XBORDER_AMOUNT_EXCEEDED",
  CUSTOMER_MONTHLY_SENDING_LIMIT_EXCEEDED = "CUSTOMER_MONTHLY_SENDING_LIMIT_EXCEEDED",
  CUSTOMER_MONTHLY_RECEIVING_LIMIT_EXCEEDED = "CUSTOMER_MONTHLY_RECEIVING_LIMIT_EXCEEDED",
  CUSTOMER_MONTHLY_RECEIVING_COUNT_EXCEEDED = "CUSTOMER_MONTHLY_RECEIVING_COUNT_EXCEEDED",
  CUSTOMER_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = "CUSTOMER_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED",
  CUSTOMER_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = "CUSTOMER_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED",
  CUSTOMER_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = "CUSTOMER_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED",
  CUSTOMER_WEEKLY_DEBIT_CASH_OUT = "CUSTOMER_WEEKLY_DEBIT_CASH_OUT",
  CUSTOMER_WEEKLY_ACH_CASH_OUT = "CUSTOMER_WEEKLY_ACH_CASH_OUT",
  CUSTOMER_WEEKLY_CASH_OUT = "CUSTOMER_WEEKLY_CASH_OUT",
  CUSTOMER_WEEKLY_REMITTANCE_SEND = "CUSTOMER_WEEKLY_REMITTANCE_SEND",
  CUSTOMER_MONTHLY_REMITTANCE_SEND = "CUSTOMER_MONTHLY_REMITTANCE_SEND",
  CUSTOMER_DAILY_WIRES_TRANSFER = "CUSTOMER_DAILY_WIRES_TRANSFER",
  CUSTOMER_WEEKLY_REMITTANCE_COUNT = "CUSTOMER_WEEKLY_REMITTANCE_COUNT",
  CUSTOMER_OUTSTANDING_BILLS_LIMIT_EXCEEDED = "CUSTOMER_OUTSTANDING_BILLS_LIMIT_EXCEEDED",
  CUSTOMER_BALANCE_LIMIT_EXCEEDED = "CUSTOMER_BALANCE_LIMIT_EXCEEDED",
  INSTRUMENT_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = "INSTRUMENT_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED",
  INSTRUMENT_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = "INSTRUMENT_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED",
  INSTRUMENT_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = "INSTRUMENT_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED",
  INSTRUMENT_WEEKLY_SENDING_LIMIT_EXCEEDED = "INSTRUMENT_WEEKLY_SENDING_LIMIT_EXCEEDED",
  INSTRUMENT_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = "INSTRUMENT_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED",
  INSTRUMENT_WEEKLY_RECEIVING_LIMIT_EXCEEDED = "INSTRUMENT_WEEKLY_RECEIVING_LIMIT_EXCEEDED",
  INSTRUMENT_MONTHLY_SENDING_LIMIT_EXCEEDED = "INSTRUMENT_MONTHLY_SENDING_LIMIT_EXCEEDED",
  INSTRUMENT_MONTHLY_RECEIVING_LIMIT_EXCEEDED = "INSTRUMENT_MONTHLY_RECEIVING_LIMIT_EXCEEDED",
  INSTRUMENT_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = "INSTRUMENT_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED",
  INSTRUMENT_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = "INSTRUMENT_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED",
  INSTRUMENT_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = "INSTRUMENT_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED",
  PER_TRANSACTION_BANK_TRANSFER_LIMIT_EXCEEDED = "PER_TRANSACTION_BANK_TRANSFER_LIMIT_EXCEEDED",
  PER_TRANSACTION_ACH_CASH_IN_LIMIT_EXCEEDED = "PER_TRANSACTION_ACH_CASH_IN_LIMIT_EXCEEDED",
  PER_TRANSACTION_PREFUND_CASH_IN_LIMIT_EXCEEDED = "PER_TRANSACTION_PREFUND_CASH_IN_LIMIT_EXCEEDED",
  PER_TRANSACTION_REMITTANCE_SEND = "PER_TRANSACTION_REMITTANCE_SEND",
  CUSTOMER_ACTIVE_LINKED_ACCOUNTS_LIMIT_EXCEEDED = "CUSTOMER_ACTIVE_LINKED_ACCOUNTS_LIMIT_EXCEEDED",
  /** UNKNOWN_MONEY_TRANSFER_FAILURE - Money Transfer Failures */
  UNKNOWN_MONEY_TRANSFER_FAILURE = "UNKNOWN_MONEY_TRANSFER_FAILURE",
  UNSUPPORTED_INSTRUMENT = "UNSUPPORTED_INSTRUMENT",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID_INSTRUMENT = "INVALID_INSTRUMENT",
  INSTRUMENT_EXPIRED = "INSTRUMENT_EXPIRED",
  INVALID_CVV_OR_EXPIRATION_DATE = "INVALID_CVV_OR_EXPIRATION_DATE",
  TRANSFER_DECLINED = "TRANSFER_DECLINED",
  INVALID_ROUTING_NUMBER = "INVALID_ROUTING_NUMBER",
  MONEY_TRANSFER_SUSPECTED_FRAUD = "MONEY_TRANSFER_SUSPECTED_FRAUD",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  INSTRUMENT_DISABLED = "INSTRUMENT_DISABLED",
  UNSUPPORTED_CURRENCY = "UNSUPPORTED_CURRENCY",
  MONEY_TRANSFER_OVER_LIMIT = "MONEY_TRANSFER_OVER_LIMIT",
  UNSUPPORTED_COUNTRY = "UNSUPPORTED_COUNTRY",
  RESTRICTED_CARD = "RESTRICTED_CARD",
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  OTHER_MONEY_TRANSFER_FAILURE = "OTHER_MONEY_TRANSFER_FAILURE",
  CUSTOMER_CHARGEBACK = "CUSTOMER_CHARGEBACK",
  DO_NOT_HONOR = "DO_NOT_HONOR",
  MISSING_MONEY_TRANSFER_FAILURE = "MISSING_MONEY_TRANSFER_FAILURE",
  CARD_LOST_OR_STOLEN = "CARD_LOST_OR_STOLEN",
  INSTANT_ACH_DISABLED = "INSTANT_ACH_DISABLED",
  /** RISK_DECLINED - Risk Check Failures */
  RISK_DECLINED = "RISK_DECLINED",
  UNKNOWN_RISK_FAILURE = "UNKNOWN_RISK_FAILURE",
  GENERAL_RISK_ERROR = "GENERAL_RISK_ERROR",
  RISK_INVALID_REQUEST = "RISK_INVALID_REQUEST",
  RISK_EVALUATION_TIMEOUT = "RISK_EVALUATION_TIMEOUT",
  PLAID_INVALID_ACCESS_TOKEN = "PLAID_INVALID_ACCESS_TOKEN",
  PLAID_ITEM_LOGIN_REQUIRED = "PLAID_ITEM_LOGIN_REQUIRED",
  /** ASYNC_CASH_IN_BLOCKED - Async cash ins are marked as failed if blockers are returned */
  ASYNC_CASH_IN_BLOCKED = "ASYNC_CASH_IN_BLOCKED",
  /** RATE_LIMITED - Business logic rate limit */
  RATE_LIMITED = "RATE_LIMITED",
  MISSING_CUSTOMER_INSTRUMENTS = "MISSING_CUSTOMER_INSTRUMENTS",
  /**
   * ONCALL_MANUAL_FAILURE - Failure reason used when an oncaller has decided to manually fail this transfer e.g due to a
   * SEV.
   */
  ONCALL_MANUAL_FAILURE = "ONCALL_MANUAL_FAILURE",
  /** NO_SOURCE_INSTRUMENT_SELECTED - Instrument selection failure reasons */
  NO_SOURCE_INSTRUMENT_SELECTED = "NO_SOURCE_INSTRUMENT_SELECTED",
  /** MISSING_FAILURE_REASON - Default when no failure reason is known */
  MISSING_FAILURE_REASON = "MISSING_FAILURE_REASON",
  /** CUSTOMER_DECLINED_PARTIAL_AUTHORIZATION - Cancellation Reasons */
  CUSTOMER_DECLINED_PARTIAL_AUTHORIZATION = "CUSTOMER_DECLINED_PARTIAL_AUTHORIZATION",
  CANCELED_BY_CALLER = "CANCELED_BY_CALLER",
  MANUAL_CANCELLATION = "MANUAL_CANCELLATION",
  AUTOMATICALLY_CANCELED = "AUTOMATICALLY_CANCELED",
  /** EXTRA_AUTHENTICATION_DISABLED - Extra authentication required but can not be processed */
  EXTRA_AUTHENTICATION_DISABLED = "EXTRA_AUTHENTICATION_DISABLED",
  EXTRA_AUTHENTICATION_DATA_INVALID = "EXTRA_AUTHENTICATION_DATA_INVALID",
  EXTRA_AUTHENTICATION_INVALID_APP_VERSION = "EXTRA_AUTHENTICATION_INVALID_APP_VERSION",
}

/** deprecated in favor of TransferRail */
export enum TransferType {
  DEBIT = "DEBIT",
  ACH = "ACH",
}

export enum OwnerType {
  CUSTOMER = "CUSTOMER",
}

export enum TransferDirection {
  INFLOW = "INFLOW",
  OUTFLOW = "OUTFLOW",
}

/** Whether the funds are available in the target instrument immediately or after some time. */
export enum ProcessingMode {
  SYNCHRONOUS = "SYNCHRONOUS",
  ASYNCHRONOUS = "ASYNCHRONOUS",
}

export enum FundingReason {
  MANUAL_CASH_IN = "MANUAL_CASH_IN",
  AUTO_CASH_IN = "AUTO_CASH_IN",
  STOCK_PURCHASE = "STOCK_PURCHASE",
  CRYPTO_PURCHASE = "CRYPTO_PURCHASE",
  LOAN_PAYMENT = "LOAN_PAYMENT",
  AUTO_STOCK_PURCHASE = "AUTO_STOCK_PURCHASE",
  AUTO_CRYPTO_PURCHASE = "AUTO_CRYPTO_PURCHASE",
  MANUAL_SAVINGS_CASH_IN = "MANUAL_SAVINGS_CASH_IN",
  CRYPTO_PURCHASE_CUSTOM = "CRYPTO_PURCHASE_CUSTOM",
  P2P_PAYMENT = "P2P_PAYMENT",
  AUTO_OVERDRAFT_PAYMENT = "AUTO_OVERDRAFT_PAYMENT",
  MANUAL_OVERDRAFT_PAYMENT = "MANUAL_OVERDRAFT_PAYMENT",
}

export enum RiskCapability {
  PARTIAL_AUTHORIZATION = "PARTIAL_AUTHORIZATION",
  CAN_OVERCOME_WITH_INSTRUMENT_VERIFICATION = "CAN_OVERCOME_WITH_INSTRUMENT_VERIFICATION",
}

export interface StoredBalanceSnapshot {
  stored_value_token?: string;
  amount?: Money;
  version?: number;
}

export interface RetryContext {
  created_at?: number;
  retry_attempt?: number;
  is_foreground?: boolean;
}

export interface RequestContext {
  client_ip?: string;
  device_id?: string;
  timezone?: string;
  user_agent?: string;
  installer_package?: string;
  drm_id?: string;
  tracking_cookie?: string;
  accept_language?: string;
  browser_fingerprint?: string;
  cash_client_scenario?: string;
  cash_flow_token?: string;
  network_operator?: string;
  sim_info?: string;
  device_name?: string;
  connectivity?: string;
  do_not_track?: string;
  square_device_info?: string;
  cell_location?: string;
  robot_detection?: string;
  host?: string;
  device_advertising_id?: string;
  device_installation_id?: string;
  device_vendor_id?: string;
  square_device_id?: string;
  retry_context?: RetryContext;
}

export interface RiskCapabilities {
  capabilities?: RiskCapability[];
}

export interface PartialAuthorizationContext {
  /** Initial amount wanted by the customer */
  initial_amount?: Money;
  /** Maximum amount allowed by the issuer */
  partial_amount_allowed?: Money;
  /** Final amount selected by the customer */
  final_amount?: Money;
}

export interface InstrumentOption {
  instrument?: Instrument;
  transfer_rail?: TransferRail;
  processing_mode?: ProcessingMode;
}

export interface SourceInstrumentOptions {
  options?: InstrumentOption[];
}

export interface CustomerContext {
  region?: Region;
  is_sponsored?: boolean;
}
